import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bordered-card w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Documents Currently On File/Pending Admin Preview", -1)
const _hoisted_3 = { class: "small mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "btn-delete small w-fit" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, " No documents have been uploaded for this dependent. ")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "action-buttons pdt-100 sm-pdl-0 sm-pdr-0 sm-pdt-50" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_DragDrop = _resolveComponent("DragDrop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: _ctx.generalError }, null, 8, ["error"]),
    (!_ctx.isEditAction)
      ? (_openBlock(), _createBlock(_component_SelectComponent, {
          key: 0,
          label: "Choose Document Type",
          selectedOption: _ctx.dependentStore.SelectedDocumentType,
          "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dependentStore.SelectedDocumentType) = $event)),
          options: _ctx.documentTypes,
          customClass: "full-width",
          error: _ctx.error
        }, null, 8, ["selectedOption", "options", "error"]))
      : _createCommentVNode("", true),
    (!_ctx.isEditAction)
      ? (_openBlock(), _createBlock(_component_DragDrop, {
          customClasses: "grey large w-100",
          onUpdateFiles: _ctx.handleFileSelection,
          key: "drag-drop-dep",
          reset: _ctx.reset,
          "onUpdate:reset": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reset) = $event)),
          onReset: _ctx.handleReset,
          loading: _ctx.loadingUpload
        }, null, 8, ["onUpdateFiles", "reset", "onReset", "loading"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        (_ctx.uploadedDocs.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedDocs, (document) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: document.DocumentID
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      href: "javascript;",
                      onClick: _withModifiers(($event: any) => (_ctx.openModal('smartsearch', null, 'modal-success', null, { DocumentID: document?.DocumentID, FilePreview: document?.FilePreview, Type: 'dependent' })), ["prevent"])
                    }, _toDisplayString(document?.Description || document?.DocumentDescription), 9, _hoisted_6)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(new Date(document.Date).toLocaleDateString()), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass({ 'text-danger': document.Status === 'Pending' })
                  }, _toDisplayString(document.Status), 3),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("i", {
                        class: "iatse-icon-trash icon_delete plan-modal fs-sm",
                        onClick: ($event: any) => (_ctx.deleteDocument(document))
                      }, null, 8, _hoisted_8)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_9, _hoisted_11))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.loadingUpload || _ctx.submitting,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
      }, " Back ", 8, _hoisted_13),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.loadingUpload || _ctx.submitting,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
      }, _toDisplayString(_ctx.buttonValue), 9, _hoisted_14)
    ])
  ], 64))
}